import { render, staticRenderFns } from "./NewProductConfigurator.vue?vue&type=template&id=20afe7f4"
import script from "./NewProductConfigurator.vue?vue&type=script&lang=js"
export * from "./NewProductConfigurator.vue?vue&type=script&lang=js"
import style0 from "./NewProductConfigurator.vue?vue&type=style&index=0&id=20afe7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports